import { Box } from '@chakra-ui/react';
import { timeTrackerSeconds } from '@whitbread-eos/utils';
import { useEffect, useMemo, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function IframeEmbed(_ref) {
  var iframeId = _ref.iframeId,
    iframeContent = _ref.iframeContent,
    onIframeLoad = _ref.onIframeLoad,
    _ref$providerUrl = _ref.providerUrl,
    providerUrl = _ref$providerUrl === void 0 ? '' : _ref$providerUrl,
    _ref$updateIframeHeig = _ref.updateIframeHeight,
    updateIframeHeight = _ref$updateIframeHeig === void 0 ? false : _ref$updateIframeHeig;
  var paymentContainerRef = useRef(null);
  var html = useMemo(() => {
    if (iframeContent) {
      return Buffer.from(iframeContent, 'base64');
    }
    return null;
  }, [iframeContent]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (html && !document.getElementById(iframeId)) {
      var _paymentContainerRef$, _iframe$contentWindow, _iframe$contentWindow2, _iframe$contentWindow3;
      var iframe = document.createElement('iframe');
      var timer = timeTrackerSeconds();
      var listen = () => {
        onIframeLoad(timer());
        iframe.removeEventListener('load', listen);
      };
      iframe.addEventListener('load', listen);
      iframe.style.width = '100%';
      iframe.style.minHeight = '58rem';
      iframe.style.height = '100%';
      iframe.style.marginBottom = 'var(--chakra-fontSizes-md)';
      paymentContainerRef === null || paymentContainerRef === void 0 || (_paymentContainerRef$ = paymentContainerRef.current) === null || _paymentContainerRef$ === void 0 || _paymentContainerRef$.appendChild(iframe);
      iframe.id = iframeId;
      iframe.allow = "payment ".concat(providerUrl);
      (_iframe$contentWindow = iframe.contentWindow) === null || _iframe$contentWindow === void 0 || _iframe$contentWindow.document.open();
      (_iframe$contentWindow2 = iframe.contentWindow) === null || _iframe$contentWindow2 === void 0 || _iframe$contentWindow2.document.write(html.toString());
      (_iframe$contentWindow3 = iframe.contentWindow) === null || _iframe$contentWindow3 === void 0 || _iframe$contentWindow3.document.close();
      return () => iframe.removeEventListener('load', listen);
    }
  }, [html, onIframeLoad]);
  return _jsx(Box, {
    w: "full",
    h: updateIframeHeight ? 'full' : 'auto',
    "data-testid": "paymentContainer",
    ref: paymentContainerRef
  });
}